import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IAsset, IFile } from '@api'
import { contractEventAssetFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  addContractEventAssets: { contractEventAssets: IAsset[] }
}

const mutateHandler = handleFetchResult<IPayload, IAsset[]>({
  handler: (data) => data.addContractEventAssets.contractEventAssets,
  name: 'Event',
})

export default async function addAssets(contractEventId: string, files: IFile[]) {
  return client.gql
    .mutate({
      mutation: addAssetsMutation,
      variables: { input: { contractEventId, files } },
    })
    .then(mutateHandler)
}

const addAssetsMutation = gql`
  mutation addContractEventAssets($input: AddContractEventAssetsInput!) {
    addContractEventAssets(input: $input) {
      contractEventAssets {
        ...ContractEventAssetFragment
      }
    }
  }
  ${contractEventAssetFragment}
`
